import React from "react";

const ITEMS = [
    "PROPERTY MANAGEMENT ROMA",
    "CHIAVI IN MANO",
    "AFFITTI BREVI",
    "FAMA LAB",
    "ZERO PENSIERI",
    "MASSIMA RESA",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            className="relative select-none overflow-hidden border-y border-[var(--fama-border)] bg-[var(--fama-ink)] py-5"
            data-testid="marquee"
        >
            <div className="fama-marquee-track">
                {row.map((item, i) => (
                    <span
                        key={i}
                        className="mx-8 inline-flex items-center gap-8 font-serif-display text-2xl tracking-[0.06em] text-[#fdfbf7] sm:text-3xl"
                    >
                        {item}
                        <span className="text-[var(--fama-gold)]">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
